import angular from 'angular';
import { property } from 'lodash-es';
import { MovingCenterActions } from './moving-center.actions';
import { MovingCenterReducer as reducer } from './moving-center.reducer';
import * as localSelectors from './moving-center.selectors';
import { utils } from '@updater/redux-http-request';

const selectors = utils.globalizeSelectors(
  localSelectors,
  property('movingCenter')
);

export { reducer, selectors };

// TODO: Remove once we convert actions to use redux-http-request
export const MovingCenterActionsModule = angular
  .module('app.actions.moving-center', [])
  .service('MovingCenterActions', MovingCenterActions);
